import React from "react";
import { Icon } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";

//
import { setActiveElement } from "redux/slices/elementsNavigationHelperReducer";
import { RootState } from "redux/store";

const getCurrentDate = () => {
  const today = new Date();
  return today.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

interface Props {
  x: number;
  y: number;
  width: number;
  height: number;
  addDrawing: any;
  signatureEncodedImgData: string;
  // signatureData: any;
  coordinateId: number;
  //
  isRequired: boolean;
  signerName?: string;
}

export const SignaturePad = ({
  x,
  y,
  width,
  height,
  addDrawing,
  signatureEncodedImgData,
  coordinateId,
  signerName,
  isRequired,
}: // signatureData,
Props) => {
  const dispatch = useDispatch();

  const elementsNavigationHelperState = useSelector(
    (state: RootState) => state.elementsNavigationHelper
  );

  return (
  <>
    {/* Signed By — ABOVE the signature box */}
    {signatureEncodedImgData && (
      <div
        style={{
          position: "absolute",
          top: y - 16,
          left: x,
          width: width,
          fontSize: "0.65rem",
          color: "#999",
        }}
      >
        <div>Signed On: {getCurrentDate()}</div>
      </div>
    )}

    <div
      className="signature-pad-container"
      style={{
        height: height,
        width: width,
        top: y,
        left: x,
      }}
      onClick={() => {
        addDrawing();
        dispatch(setActiveElement({ coordinateId, y, x }));
      }}
    >
      {signatureEncodedImgData ? (
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            overflow: "hidden",
          }}
          className="active-data-container-signature"
        >
          <img
            src={signatureEncodedImgData}
            alt={"imgg"}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              display: "block",
            }}
          />
          {isRequired && (
            <span
              style={{
                position: "absolute",
                fontWeight: "bold",
                color: "#BB2525",
                fontSize: "1.2rem",
                top: 0,
                right: "-10px",
              }}
            >
              *
            </span>
          )}
        </span>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
          className="active-data-container-signature"
        >
          <div>Signature</div>
          {isRequired && (
            <span
              style={{
                position: "absolute",
                fontWeight: "bold",
                color: "#BB2525",
                fontSize: "1.2rem",
                top: 0,
                right: "-10px",
              }}
            >
              *
            </span>
          )}
        </div>
      )}
    </div>

    {/* Signed On — BELOW the signature box */}
    {signatureEncodedImgData && (
      <div
        style={{
          position: "absolute",
          top: y + height + 2,
          left: x,
          width: width,
          fontSize: "0.65rem",
          color: "#999",
           
        }}
      >
        <div>Signed By: {signerName || "N/A"}</div>
      </div>
    )}
  </>
);
};
